import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

import { DropdownOptionModel }       from '../shared/components/dropdown/typings/dropdown-option';
import { IntelligenceFormatService } from './intelligence.format.service';

// above this many options a dropdown outgrows the viewport, so the filter becomes a search
const SEARCH_THRESHOLD = 15;

@Component({
  selector   : 'wor-intelligence-filter',
  template: require('./intelligence.filter.component.html')
})
export class FilterComponent implements OnChanges {
  @Input() allLabel    : string = '';
  @Input() label       : string = '';
  @Input() name        : string = '';
  @Input() options     : Array<string> = [];
  @Input() placeholder : string = '';
  @Input() value       : string = '';

  @Output() changed = new EventEmitter<string>();

  public dropdownOptions : Array<DropdownOptionModel> = [];

  constructor (
    private intelligenceFormatService: IntelligenceFormatService
  ) {}

  // rebuilt only when an input changes; the empty value is the "all" choice
  ngOnChanges () : void {
    this.dropdownOptions = [ { label: this.allLabel, value: '' } ]
      .concat(( this.options || [] ).map(option => ({ label: option, value: option })));
  }

  // the typeahead clears as an empty model, so reset only a set filter and never on a partial term
  clearIfEmpty ( value : string ) : void {
    if ( !value && this.value ) {
      this.changed.emit('');
    }
  }

  isSearch () : boolean {
    return ( this.options || [] ).length > SEARCH_THRESHOLD;
  }

  search = ( query : string ) : Promise<Array<string>> => {
    return Promise.resolve(this.intelligenceFormatService.matchOptions(this.options, query));
  }

  select ( value : string ) : void {
    if ( value !== this.value ) {
      this.changed.emit(value);
    }
  }
}
